import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Button from "./Button";
import Input from "./Input";
import Icon from "../AppIcon";
import { useCreateFuctionMutation } from "store/dynamicApi";
import Swal from "sweetalert2";

const CardRegistrationModal = ({ isOpen, onClose, onSubmit }) => {
  const [isCustom, setIsCustom] = useState(false)
  const [card, setCard] = useState('');

  const [
    createFuction,
    { isError: CIsError, error: Cerror, data: CData, isLoading: CIsLoading },
  ] = useCreateFuctionMutation();



  useEffect(() => {
    const showAlert = async (msg, icon = "error") => {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      toast.fire({
        icon: icon,
        title: msg,
        padding: "10px 20px",
      });
    };

    if (CIsError) {
      showAlert(Cerror?.data?.msg);
    }

    if (CData) {
      showAlert(CData?.msg, "success");
    }
  }, [CIsError, Cerror, CData]);

  const handleSubmit = async () => {
    try {
      const cardData = {
        type: "provider",
        isCustom: isCustom ? 'custom' : 'generate',
        card
      };
      const url = "/card/register";
      await createFuction({ formData: cardData, url }).unwrap();
      handleClose();
    } catch (error) {
      console.error("Registration failed:", error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Register New NFC Card"
      size="lg"
      closeOnOverlayClick={false}
    >
      <div className="p-6">
        <Button
          variant="primary"
          onClick={() => setIsCustom(!isCustom)}
        >
          {isCustom ? "Custome Card" : "Generate Card"}
        </Button>
        {
          isCustom ? (
            <div className="space-y-3">


              <div className="mt-2">
                <label className="text-white form-label">
                  Card Number
                </label>
                <input
                  type="test"
                  value={card}
                  onChange={(e)=> setCard(e.target.value)}
                  className='form-input'
                  placeholder="number"
                />
              </div>

              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={CIsLoading}
                loading={CIsLoading}
              >
                {CIsLoading ? "Registering..." : "Register Card"}
              </Button>
            </div>
          ) : (
            <div className="mt-2">
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={CIsLoading}
                loading={CIsLoading}
              >
                {CIsLoading ? "Generating..." : "Generate Card"}
              </Button>
            </div>
          )
        }



      </div>
    </Modal>
  );
};

export default CardRegistrationModal;
